// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_h0F","cls2":"CiterightMiniReport-cls2_OLv CiterightMiniReport-cls1_h0F"};